module.exports = __webpack_public_path__ + "img/4.e525997a.png";